module.exports = __webpack_public_path__ + "static/media/helsinki-16.4cfeaf60.jpg";